import { useCallback, useEffect, useState } from "react";
import { fetchPartInfoOptions, addPartInfo } from "../../models/shared/partInfoModel";

export function usePartInfoOptions() {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPartInfoOptions().then(list => {
      setOptions(list);
      setLoading(false);
    });
  }, []);

  const addOption = useCallback(async (value) => {
    const res = await addPartInfo(value);
    setOptions(prev => [...prev, { value, label: value }]);
    return res;
  }, []);

  return { options, loading, addOption, setOptions };
}
